export const FN = {
  adviceLength:
      "Prénom doit contenir entre 3 et 25 caractéres",
    // "First name must contain between 3 and 25 characters",
  adviceContent:
    //   "Prénom contient que des majuscules et minuscules",
    "First name contains only uppercase and lowercase",
};
export const LN = {
  adviceLength:
      "Nom doit contenir entre 3 et 25 caractéres",
    // "Last name must contain between 3 and 25 characters",
  adviceContent:
      "Nom contient que des majuscules et minuscules",
    // "Last name contains only uppercase and lowercase",
};

export const E_MAIL = {
  adviceLength:
    "Email doit contenir entre 5 et 25 caractéres",
    // "Email must contain minimum 5 characters",
  adviceContent:
      "Email incorrect. Ex: pierre@gmail.com",
    // "Email format incorrect. Ex: john@gmail.com",
};

export const TEL = {
  adviceLength: "Telephone doit contenir entre 10 et 13 caractéres",
  adviceContent: "Telephone incorrect. Ex: 0123456789 où Ex: 0033123456789",
};
export const MSG = {
  adviceLength: "Message doit contenir minimum 10 caractéres",
  adviceContent: "Message contient des caractères non reconnus",
};
